<template>
  <div class="container">
    <h1 class="display-6 text-center">Courses We Offer</h1>
    <p class="lead text-center mb-5">
      Explore our diverse range of academic courses designed to support students from KS3 and GCSE through to A-Level and university modules. Whether you’re looking for a structured program or flexible one-to-one support, we have something for every learner.
    </p>
   <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
      <div class="col" v-for="(course, index) in courses" :key="index">
        <div class="card h-100 shadow-sm">
          <div class="card-body">
            <h5 class="card-title fw-semibold fs-5">{{ course.title }}</h5>
            <h6 class="card-subtitle mb-2 text-muted fs-6">{{ course.level }}</h6>
            <p class="card-text fs-6 lh-base">{{ course.description }}</p>
        
          </div>
          <div class="card-footer bg-transparent border-top-0">
            <button class="btn btn-custom"  @click="openModal(course)">View More</button>
          </div>
        </div>
      </div>
</div>

    
  </div>
 <!-- Modal -->
<div
  class="modal fade"
  tabindex="-1"
  :class="{ show: showModal }"
  style="display: block;"
  v-if="showModal"
>
  <div class="modal-dialog">
    <div class="modal-content border-0 shadow-lg">
      <div class="modal-header">
        <h5 class="modal-title">{{ selectedCourse.title }}</h5>
        <button type="button" class="btn-close" @click="closeModal"></button>
      </div>
      <div class="modal-body">
        <p><strong>Topics Covered:</strong></p>
        <ul>
          <li v-for="(topic, index) in selectedCourse.topics" :key="index">{{ topic }}</li>
        </ul>
      <p class="text-success">Detailed learning objectives and outcomes are available.</p>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" @click="closeModal">Close</button>
      </div>
    </div>
  </div>
</div>

</template>

<script>
export default {
  name: 'CoursesView',
  data() {
    return {
       selectedCourse: null,
       showModal: false,
      courses: [
        {
          id: 1,
          title: 'Practical Project',
          level: 'A-level',
          description: 'Provides a comprehensive exploration of different components of programming project, through clear explanations tailored to exam & syllabus requirements.',
            topics: [
          "Stages of development life cycle",
          "Development methodology (OOP)",
          "Effective portfolio/documentation",
          "Refining your work",
          "Effective and engaging practices"
        ]
        },
        {
          id: 2,
          title: 'Object Orientation Programming (OOP)',
          level: 'A-Level',
          description: 'Learn the OOP approach to develop or transform a program/app, that is easy to design, construct, modify and debug.',
            topics: ["Understanding the real-world objects aound us",
                    "Identifying the characteristics + behaviour of objects",
                    "How objects represented in the virtual/program environment",
                    "Properties of OOP",
                    "Conceptualizing program as a collection of objects",
                    "How objects communicate & interact during the execution of program",
                    "Developing an app using the OOP approach"
            ]
        },
        {
          id: 3,
          title: 'Introduction to Cybersecurity',
          level: 'Enrichment',
          description: 'In this course, we’ll explore how cybersecurity quietly supports us every day to protect our digital life— when we log in, shop online, or sign up for services.',
           topics: [
            
           "Cybersecurity is not just about defending against attackers and viruses — it’s about how we keep our information safe, build trust in online systems, and make technology work securely for everyone.",

          "Through practical examples and clear explanations, we’ll learn how digital systems protect our identity, data, and actions.",

          "You’ll leave this course with a better understanding of how cybersecurity works for you — not just against threats",
           
           "Learning Outcomes",

            "By the end of this course, you will be able to:",

             "1) Distinguish between cyberspace, networks, and the Internet, and explain their roles in digital communication.",

            "2) Understand the purpose of cybersecurity and how it helps protect data, identity, and transactions.",

            "3) Recognize real-world applications of cybersecurity, such as:",

               "  3.1) Logging into an online platform using Google or other identity providers.",
               "  3.2) Safely completing an online shopping transaction.",
               "  3.3) Verifying your identity via email confirmation and registration systems.",




           ]
        },
        {
          id: 4,
          title: 'Foundations of AI: Key Concepts and Algorithms',
          level: 'GCSE & A-Level Students',
          description: 'A hands-on workshop series exploring AI concepts & basic algorithms to get confident first start to built-on.',
           topics: ["How automated systems evolved into present intelligent systems",
                  "Introduction to AI",
                  "Types of AI",
                  "Fundemental ideas in AI",
                  "How Path finding algorithms helps us understand AI",
                  "Applying the basic AI algorthims to different practical scenarios."
           ]
        },
         {
          id: 5,
          title: 'Weekend Workshops',
          level: 'Python Programming',
          description: 'Learn the Python with practical examples to develop and enhance your coding skills to work on school labs, assignments & projects.',
           topics: ["Coming soon..."]
        },
         {
          id: 6,
          title: 'Cybersecurity Essentials for GCSE & A-Level Teachers',
          level: 'Training for teachers',
          description: 'Understand the building blocks of cybersecruity, along with learning platforms threats and safety measures for students.'
          
      
          ,
           topics: ["Cybersecurity in Online Learning Platforms",
                    "Relation of Vulnerability, Threat & Risk",
                    "Understanding Cyber Attacks & Attack Vectors" ,
                    "Strategies to reduce Vulnerability, Threat & Risk",
                    "How to minimize the access/loss/damage",
                    "Combining Cybersecurity in the Classroom"]
        }
      ]
    }
  },
  methods: {
    openModal(course) {
      this.selectedCourse = course;
      this.showModal = true;
      document.body.classList.add("modal-open"); // Prevents scroll flicker
    },
    closeModal() {
      this.showModal = false;
      this.selectedCourse = null;
      document.body.classList.remove("modal-open");
    }
  }




}
</script>

<style scoped>
.card-title {
  font-weight: bold;
}
.card {
  border: 1px solid #d4eadd;
  background-color: #f9fdfb; /* light green background */
}

.card-title {
  color: #1e5f3d; /* dark green */
  font-weight: bold;
}

.card-text {
  color: #333;
}

.badge {
  background-color: #198754; /* Bootstrap's success green */
}

.btn-custom {
  background-color: #198754; /* Green */
  color: white;
  border: 2px solid #198754;
  transition: all 0.3s ease;
}

.btn-custom:hover {
  background-color: white;
  color: #198754;
  border: 2px solid #198754;
}

.modal {
  background: rgba(0, 0, 0, 0.5);
  overflow: auto;
}
.modal-open {
  overflow: hidden;
}
</style>
